module.exports = __webpack_public_path__ + "img/user-guide-02-05-03.7ec55ba3.png";